import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ProfileRoutingModule} from './profile-routing.module';
import {ProfileComponent} from './profile/profile.component';
import {UiKitsModule} from '../../shared/ui-kits/ui-kits.module';
import {ProfessionalDataComponent} from './professional-data/professional-data.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SalaryComponent} from './salary/salary.component';
import {GeneralComponent} from './general/general.component';
import {PersonalDataComponent} from './personal-data/personal-data.component';

import {DialogModule} from '../../shared/ui-kits/dialog/dialog.module';
import {HrDataComponent} from './hr-data/hr-data.component';
import {OneToOneComponent} from './hr-data/one-to-one/one-to-one.component';
import {PerformanceReviewComponent} from './hr-data/performance-review/performance-review.component';
import {PromotionComponent} from './hr-data/promotion/promotion.component';
import {ValuesAndHobbiesComponent} from './hr-data/values-and-hobbies/values-and-hobbies.component';
import {SalaryRecruiterComponent} from './salary-recruiter/salary-recruiter.component';
import {GeneralRecruiterComponent} from './general-recruiter/general-recruiter.component';
import {WrapperProfileComponent} from './wrapper-profile/wrapper-profile.component';
import {AddingEmployeeComponent} from './adding-employee/adding-employee.component';
import {ContainsPipe} from '../../pipes/contains.pipe';
import {TopicsComponent} from './hr-data/topics/topics.component';
import {PeDataComponent} from './pe-data/pe-data.component';
import {BankInfoComponent} from './bank-info/bank-info.component';
import {NewBankPopupComponent} from './bank-info/new-bank-popup/new-bank-popup.component';
import {CardNumberPopupComponent} from './bank-info/card-number-popup/card-number-popup.component';
import {AutentificationCredentialsPopupComponent} from './bank-info/autentification-credentials-popup/autentification-credentials-popup.component';
import {AgreementPopupComponent} from './bank-info/agreement-popup/agreement-popup.component';
import {AsteriskModule} from 'src/app/directives/mark-asterisk/mark-asterisk.module';
import {MaternityPopupComponent} from './general/maternity-popup/maternity-popup.component';
import {SalaryExtendedComponent} from './salary-extended/salary-extended.component';
import {IncreaseSalaryPopupComponent} from './salary-extended/increase-salary-popup/increase-salary-popup.component';
import {LongTermLeavePopupComponent} from './general/long-term-leave/long-term-leave-popup.component';
import {VacationPopupComponent} from './salary-extended/vacation-popup/vacation-popup.component';
import {BcoinComponent} from './bcoin/bcoin.component';
import {WorkingPeriodPopupComponent} from './general/working-period-popup/working-period-popup.component';
import {PersonalRecruiterComponent} from './personal-recruiter/personal-recruiter.component';
import {IncreaseEmploymentPositionFormComponent} from './general/working-period-popup/increase-employment-position-form/increase-employment-position-form.component';
import {DecreaseEmploymentPositionFormComponent} from './general/working-period-popup/decrease-employment-position-form/decrease-employment-position-form.component';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';

@NgModule({
  declarations: [
    ProfileComponent,
    ProfessionalDataComponent,
    SalaryComponent,
    SalaryExtendedComponent,
    IncreaseSalaryPopupComponent,
    GeneralComponent,
    PersonalDataComponent,
    HrDataComponent,
    OneToOneComponent,
    PerformanceReviewComponent,
    PromotionComponent,
    ValuesAndHobbiesComponent,
    SalaryRecruiterComponent,
    GeneralRecruiterComponent,
    WrapperProfileComponent,
    AddingEmployeeComponent,
    ContainsPipe,
    TopicsComponent,
    PeDataComponent,
    BankInfoComponent,
    NewBankPopupComponent,
    CardNumberPopupComponent,
    AutentificationCredentialsPopupComponent,
    AgreementPopupComponent,
    MaternityPopupComponent,
    LongTermLeavePopupComponent,
    VacationPopupComponent,
    BcoinComponent,
    WorkingPeriodPopupComponent,
    PersonalRecruiterComponent,
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    UiKitsModule,
    ReactiveFormsModule,
    DialogModule,
    NgxMaskDirective,
    AsteriskModule,
    IncreaseEmploymentPositionFormComponent,
    DecreaseEmploymentPositionFormComponent,
  ],
  exports: [ProfileComponent],
  providers: [provideNgxMask()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProfileModule {}
